import { createContext } from "react";

const MekhrazContext = createContext({
  mekhrazUpdated: false,
  setMekhrazUpdated: (updt) => {},
});

export default MekhrazContext;
